// pages/Dashboard/Staff.js
function Staff() {
  return <h2>Staff</h2>;
}

export default Staff;